import script from "./MsgMine.vue?vue&type=script&setup=true&lang=ts"
export * from "./MsgMine.vue?vue&type=script&setup=true&lang=ts"

import "./MsgMine.vue?vue&type=style&index=0&id=1bce5174&lang=scss"

const __exports__ = script;

export default __exports__